<nav class="navbar navbar-expand-lg navbar-dark bg-dark shadow d-print-none flex-md-nowrap p-3">
    <a class="navbar-brand" routerLink="/admin/tablero">{{ conf?.name }}</a>

    <button class="navbar-toggler" type="button" (click)="isCollapsed = !isCollapsed" aria-controls="navbarNav"
        [attr.aria-expanded]="!isCollapsed" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div [ngbCollapse]="isCollapsed" class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
                <a class="nav-link" routerLink="/admin/mercaderias/lst" routerLinkActive="active">Mercaderías</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" routerLink="/admin/ingresos/lst" routerLinkActive="active">Compras</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" routerLink="/admin/ventas/lst" routerLinkActive="active">Ventas</a>
            </li>
        </ul>

        <form class="d-flex align-items-center">
            <input class="form-control me-2 bg-dark text-success" readonly disabled type="text" placeholder="Usuario"
                [value]="getuser()?.nombre | uppercase" />
            <button (click)="cerrar()" class="btn btn-outline-danger" type="button">
                Cerrar
            </button>
        </form>
    </div>
</nav>